/* 🤖 this file was generated by svg-to-ts */
export const mgcIconRectangleVerticalCuteFi: {
  name: 'rectangle-vertical-cute-fi';
  data: string;
} = {
  name: 'rectangle-vertical-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M8.96 1.545a50 50 0 0 1-.64.057c-1.488.128-2.439.501-3.256 1.278-.895.851-1.288 1.764-1.471 3.42-.077.697-.077 10.703 0 11.4.114 1.027.297 1.711.623 2.324.228.429.454.72.849 1.096.888.846 1.843 1.183 3.735 1.321.701.051 5.699.051 6.4 0 2.171-.158 3.226-.616 4.196-1.822.645-.802.934-1.771 1.045-3.499.061-.95.031-10.344-.035-10.86-.205-1.6-.524-2.394-1.286-3.196-.837-.88-1.737-1.274-3.36-1.468-.354-.043-6.443-.089-6.8-.051"/></svg>`
};
